import { Thread } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { Thread as UnifiedThread } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v2/models.pb';
import { CachedEndpointData, ResourceMatchingOptions } from '../types';
import { combinedThreadMatchFn, combinedUnifiedThreadMatchFn } from './combined-resource-match-functions';

export const findCachedThreadInListThreads = (
  queries: CachedEndpointData<'ListThreads'>[],
  {
    matchFn,
    matchValues,
    matchStrategy,
  }: Pick<ResourceMatchingOptions<Thread>, 'matchValues' | 'matchFn' | 'matchStrategy'>
) => {
  for (const query of queries) {
    for (const page of query.pages) {
      for (const thread of page.threads) {
        const isMatch = combinedThreadMatchFn({ matchValues, matchFn, matchStrategy })(thread);
        if (isMatch) {
          return thread;
        }
      }
    }
  }
  return undefined;
};

export const findCachedUnifiedThreadInListUnifiedThreads = (
  listUnifiedThreadsData: (CachedEndpointData<'ListUnifiedThreads'> | undefined)[],
  { matchValues, matchStrategy, matchFn }: ResourceMatchingOptions<UnifiedThread>
): UnifiedThread | undefined => {
  const matchFunction = combinedUnifiedThreadMatchFn({ matchValues, matchFn, matchStrategy });

  for (const data of listUnifiedThreadsData) {
    if (!data?.pages) continue;

    for (const page of data.pages) {
      if (!page?.threads) continue;

      for (const thread of page.threads) {
        if (matchFunction(thread)) {
          return thread;
        }
      }
    }
  }

  return undefined;
};
